import axios from "axios";
//Limitless imports
import { log as pilog } from "@limitless/common/utils";
import { createPlatformURL, handleSecureAjaxError, createMutationHeaders } from "../../../portal";
import { INVITED } from "../../../portal/utils/Constants";
const getProfileAdditionalHeaders = () => {
  const profileHeaders = {
    "App-Name": process.env.REACT_APP_NAME.toLowerCase(),
    "App-Type": process.env.REACT_APP_TYPE ? process.env.REACT_APP_TYPE : "web",
    "App-Version": process.env.REACT_APP_VERSION
  };
  if (process.env.REACT_MOBILE_DEVICE_TYPE) {
    profileHeaders["Device-Type"] = process.env.REACT_MOBILE_DEVICE_TYPE;
  }
  return profileHeaders;
};

/**
 * Load the Users Profile from the Platform
 */
export const loadProfile = () => {
  const url = createPlatformURL("profile");
  const body = {};
  if (!process.env.REACT_APP_TYPE || process.env.REACT_APP_TYPE === "web") {
    body.lastWebAppVersionUsed = process.env.REACT_APP_VERSION;
  } else {
    body.lastMobileAppVersionUsed = process.env.REACT_APP_VERSION;
  }
  return new Promise((resolve, reject) => {
    axios.put(url, body, createMutationHeaders({}, getProfileAdditionalHeaders())).then(res => {
      const profile = res.data;
      if (!profile.country) {
        profile.language = "en";
        profile.country = "GB";
      }
      profile.userLocale = `${profile.language}-${profile.country}`;
      const {
        groups
      } = profile;
      if (profile.firstName) {
        profile.author = `${profile.firstName} ${profile.lastName ? profile.lastName.charAt(0) : ""}`.trim();
      }
      if (groups && groups.length !== 0) {
        const finalGroups = [];
        groups.map(group => {
          finalGroups.push({
            groupName: group.groupName,
            tenantName: group.tenantName,
            displayName: group.displayName ? group.displayName : group.groupName,
            tenantDisplayName: group.tenantDisplayName ? group.tenantDisplayName : group.tenantName,
            membershipState: group.membershipState || "active",
            productionGroup: group.productionGroup || false,
            qualityReviewGroup: group.qualityReviewGroup || false,
            practiceGroup: group.practiceGroup || false
          });
        });
        profile.groups = finalGroups;
        profile.isOnboaridngInviteChecked = profile.groups.some(group => group.membershipState === INVITED) && !profile.groups.some(group => group.membershipState === "active");
      }
      Reflect.deleteProperty(profile, "picture");
      resolve(profile);
    }).catch(error => {
      handleSecureAjaxError(error, "ExpertProfileAPI loadProfile");
      reject();
    });
  });
};

/**
 * Save changes to the profile
 *
 * @param {object} profile
 */
export const saveProfileChanges = profile => {
  const url = createPlatformURL("profile");
  return new Promise((resolve, reject) => {
    axios.put(url, profile, createMutationHeaders({}, getProfileAdditionalHeaders())).then(res => {
      const updatedProfile = res.data;
      //handle the case where we remove the picture
      if (!res.data.pictureAvailable) {
        updatedProfile.picture = "";
        updatedProfile.thumbnail = "";
      } else {
        updatedProfile.address2 = res.data.address2 || "";
      }
      resolve(updatedProfile);
    }).catch(error => {
      handleSecureAjaxError(error, "ExpertProfileAPI saveProfileChanges");
      reject(error.response.data);
    });
  });
};
export const loadProfileImage = () => {
  const url = createPlatformURL("profile/image");
  return new Promise(resolve => {
    axios.get(url, createMutationHeaders()).then(result => {
      resolve(result.data.image);
    }).catch(error => {
      handleSecureAjaxError(error, "ExpertProfileAPI loadProfileImage");
      resolve("");
    });
  });
};

/**
 * Subscribe push notification token
 *
 * @param {object} tokenObj
 */
export const subscribeToPushService = tokenObj => {
  const log = pilog.getLogger("ExpertProfileAPI subscribeToPushService");
  const url = createPlatformURL("profile/push/subscribe");
  axios.put(url, tokenObj, createMutationHeaders()).then(res => {
    log.debug("Push subscribed success ", res.data);
  }).catch(error => {
    handleSecureAjaxError(error, "ExpertProfileAPI subscribeToPushService");
  });
};